import React, { useReducer } from 'react'
export const WorkoutContext = React.createContext({})

const initialState = {
  all: '--',
  calorie: '--',
  progress: '--',
  rank: '--',
  recordId: '--',
  workoutTime: '--',
  heartRate: '--',
  rated: false,
  workoutName: '--',
  browseSearchValue: {},
  browseSearchData: {},
  // workoutName: 'Kick-Ass Cardio Crush',
}

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_WORKOUT':
      return {
        ...state,
        ...action.payload,
      }
    case 'INIT_WORKOUT':
      return {
        ...initialState,
      }
    default:
      throw new Error()
  }
}

export const WorkoutContextProvider = (Children) => {
  const Provider = (props) => {
    const [state, dispatch] = useReducer(reducer, initialState)
    return (
      <WorkoutContext.Provider value={{ state, dispatch }}>
        <Children {...props} />
      </WorkoutContext.Provider>
    )
  }
  return Provider
}
